import { createAction } from '@reduxjs/toolkit'

import type {
  TDerivedMetricDto,
  TDerivedMetricOptionsDto,
  TDerivedMetricPreviewDto
} from '@homepal/api-contract'

// tryGetDerivedMetrics
export const getAll = createAction('get_derived_metrics')
export const getAllSuccess = createAction<TDerivedMetricDto[]>(
  'get_derived_metrics_success'
)
export const getAllFailed = createAction('get_derived_metrics_failed')

// tryGetDerivedMetricOptions
export const getOptions = createAction('get_derived_metric_options')
export const getOptionsSuccess = createAction<TDerivedMetricOptionsDto>(
  'get_derived_metric_options_success'
)
export const getOptionsFailed = createAction(
  'get_derived_metric_options_failed'
)

// tryPreviewDerivedMetric
export const preview = createAction('preview_derived_metric')
export const previewSuccess = createAction<TDerivedMetricPreviewDto>(
  'preview_derived_metric_success'
)
export const previewFailed = createAction('preview_derived_metric_failed')

// tryCreateDerivedMetric
export const create = createAction('create_derived_metric')
export const createSuccess = createAction<TDerivedMetricDto>(
  'create_derived_metric_success'
)
export const createFailed = createAction('create_derived_metric_failed')

// tryUpdateDerivedMetric
export const update = createAction('update_derived_metric')
export const updateSuccess = createAction<TDerivedMetricDto>(
  'update_derived_metric_success'
)
export const updateFailed = createAction('update_derived_metric_failed')

// tryDeleteDerivedMetric
export const destroy = createAction('delete_derived_metric')
export const destroySuccess = createAction<string>(
  'delete_derived_metric_success'
)
export const destroyFailed = createAction('delete_derived_metric_failed')
